import React from "react"
import { useTranslation } from "react-i18next"

import { Select, TextField } from "components"
import PrinterDriversList from "./PrinterDriversList"
import PrinterBluetoothInterface from "./PrinterBluetoothInterface"
import classes from "./PrinterForm.module.scss"

const printerWidthOptions = [
  { label: "80", value: 80 },
  { label: "58", value: 58 }
]

const printerPaperWidthOptions = {
  80: [
    { label: "72", value: 72 },
    { label: "64", value: 64 }
  ],
  58: [
    { label: "54", value: 54 },
    { label: "48", value: 48 }
  ]
}

const printerResolutionOptions = [
  { label: "203 dpi (8 dots/mm)", value: 8 },
  { label: "180 dpi (7 dots/mm)", value: 7 }
]

const printerTypesOptions = [
  { label: "EPSON", value: "epson" },
  { label: "STAR", value: "star" },
  { label: "TANCA", value: "tanca" }
]

const printerInterfacesOptions = [
  { label: "Network", value: "tcp" },
  { label: "Bluetooth", value: "bluetooth" },
  { label: "USB", value: "usb" }
]

const PrinterForm = props => {
  const { forPos, form, setForm, formErrors } = props

  const [t] = useTranslation()

  const handleChange = (value, name) => {
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleChangeInterface = (value) => {
    if (value === "tcp") {
      setForm(prev => ({
        ...prev,
        deviceId: 0,
        productId: 0,
        printerInterface: value
      }))

      return
    }

    setForm(prev => ({
      ...prev,
      printerInterface: value
    }))
  }

  const handleChangePrinterWidth = (value) => {
    setForm(prev => ({
      ...prev,
      printerWidth: value,
      printerPaperWidth: value === 80 ? 72 : 54
    }))
  }

  const handleChangeModel = (value) => {
    setForm(prev => ({
      ...prev,
      deviceId: 0,
      productId: 0,
      deviceName: "",
      pageSize: "",
      printerModel: value
    }))
  }

  const showTcpOptions =
    form.printerModel === "thermal" &&
    form.printerInterface === "tcp"

  const showBluetoothOptions =
    form.printerModel === "thermal" &&
    form.printerInterface === "bluetooth"

  const showPrinterInterface =
    form.printerModel === "thermal"

  const showPrinterType =
    form.printerModel === "thermal"

  const showPrinterWidth =
    form.printerModel === "thermal"

  const showPrinterPaperWidth =
    form.printerModel === "thermal"

  const showPrinterResolution =
    form.printerModel === "thermal"

  const showDriversList =
    form.printerModel === "thermal"
      ? !forPos && form.printerInterface === "usb"
      : true



  const printerModelOptions = [
    { label: t("حرارتی"), value: "thermal" },
    { label: t("چاپگر_لیبل"), value: "label" },
    { label: t("لیزری"), value: "laser" },
    { label: t("فکس"), value: "fax" }
  ]

  return (
    <div className={classes["container"]}>
      <TextField
        disabled={forPos}
        className={classes["name"]}
        maxLength={100}
        label={t("اسم_پرینتر")}
        value={form.printerName}
        error={formErrors.printerName}
        onChange={(e) => handleChange(e.target.value, "printerName")}
      />
      <Select
        isDisabled={forPos}
        isSearchable={false}
        className={classes["select"]}
        options={printerModelOptions}
        label={t("مدل_پرینتر")}
        onChange={(select) => handleChangeModel(select.value)}
        error={formErrors.printerModel}
        value={
          printerModelOptions.find(o =>
            o.value === form.printerModel
          )
        }
      />
      {
        showPrinterInterface &&
        <Select
          isDisabled={forPos}
          isSearchable={false}
          options={printerInterfacesOptions}
          className={classes["select-1"]}
          label={t("نوع_ارتباط_پرینتر")}
          onChange={(select) => handleChangeInterface(select.value)}
          error={formErrors.printerInterface}
          value={
            printerInterfacesOptions.find(o =>
              o.value === form.printerInterface
            )
          }
        />
      }
      {
        showTcpOptions &&
        <TextField
          disabled={forPos}
          withoutSpace
          className={classes["input"]}
          label={t("آدرس_Ip_پرینتر")}
          value={form.ipAddress}
          onChange={(e) => handleChange(e.target.value, "ipAddress")}
          error={formErrors.ipAddress}
        />
      }
      {
        showDriversList &&
        <PrinterDriversList
          form={form}
          setForm={setForm}
          formErrors={formErrors}
        />
      }
      <TextField
        disabled={forPos}
        withoutSpace
        className={classes["input"]}
        label={t("آدرس_Ip_سرور_پرینتر_محلی")}
        value={form.localPrintServerIpAddress}
        onChange={(e) => handleChange(e.target.value, "localPrintServerIpAddress")}
        error={formErrors.localPrintServerIpAddress}
      />
      {
        showBluetoothOptions &&
        <PrinterBluetoothInterface
          form={form}
          setForm={setForm}
          formErrors={formErrors}
        />
      }
      {
        showPrinterType &&
        <Select
          isDisabled={forPos}
          isSearchable={false}
          className={classes["select-2"]}
          options={printerTypesOptions}
          label={t("نوع_پرینتر")}
          onChange={(select) => handleChange(select.value, "printerType")}
          error={formErrors.printerType}
          value={
            printerTypesOptions.find(o =>
              o.value === form.printerType
            )
          }
        />
      }
      {
        showPrinterWidth &&
        <Select
          isDisabled={forPos}
          isSearchable={false}
          className={classes["select-3"]}
          label={t("طول_پرینتر_mm")}
          options={printerWidthOptions}
          onChange={(select) => handleChangePrinterWidth(select.value)}
          error={formErrors.printerWidth}
          value={
            printerWidthOptions.find(o =>
              o.value === form.printerWidth
            )
          }
        />
      }
      {
        showPrinterPaperWidth &&
        <Select
          isDisabled={forPos}
          isSearchable={false}
          className={classes["select-3"]}
          options={printerPaperWidthOptions[form.printerWidth]}
          label={t("طول_کاغظ_mm")}
          onChange={(select) => handleChange(select.value, "printerPaperWidth")}
          error={formErrors.printerInterface}
          value={
            printerPaperWidthOptions[form.printerWidth].find(o =>
              o.value === form.printerPaperWidth
            )
          }
        />
      }
      {
        showPrinterResolution &&
        <Select
          isDisabled={forPos}
          isSearchable={false}
          className={classes["select-2"]}
          options={printerResolutionOptions}
          label={t("کیفیت_پرینتر")}
          onChange={(select) => handleChange(select.value, "printerResolution")}
          error={formErrors.printerInterface}
          value={
            printerResolutionOptions.find(o =>
              o.value === form.printerResolution
            )
          }
        />
      }

      {
        showPrinterWidth &&
        <Select
          isDisabled={forPos}
          isSearchable={false}
          className={classes["select-3"]}
          label={t("کاتر_پرینتر")}
          options={[
            { label: t("فعال"), value: true },
            { label: t("غیر_فعال"), value: false }
          ]}
          value={{
            label: form.printerCutter ? t("فعال") : t("غیر_فعال"),
            value: !!form.printerCutter
          }}
          onChange={(select) => handleChange(select.value, "printerCutter")}
        />
      }
    </div>
  )
}

export default PrinterForm